"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commABI = void 0;
exports.commABI = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'channel',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'delegate',
                type: 'address',
            },
        ],
        name: 'AddDelegate',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: '_chainName',
                type: 'string',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: '_chainID',
                type: 'uint256',
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_channelOwnerAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'string',
                name: '_ethereumChannelAddress',
                type: 'string',
            },
        ],
        name: 'ChannelAlias',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'publickey',
                type: 'bytes',
            },
        ],
        name: 'PublicKeyRegistered',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'channel',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'delegate',
                type: 'address',
            },
        ],
        name: 'RemoveDelegate',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'channel',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'identity',
                type: 'bytes',
            },
        ],
        name: 'SendNotification',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'channel',
                type: 'address',
            },
            { indexed: true, internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'Subscribe',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'channel',
                type: 'address',
            },
            { indexed: true, internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'Unsubscribe',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: '_channel',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: '_user',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_notifID',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'string',
                name: '_notifSettings',
                type: 'string',
            },
        ],
        name: 'UserNotifcationSettingsAdded',
        type: 'event',
    },
    {
        inputs: [],
        name: 'DOMAIN_TYPEHASH',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'EPNSCoreAddress',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'NAME_HASH',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'SEND_NOTIFICATION_TYPEHASH',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'SUBSCRIBE_TYPEHASH',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'UNSUBSCRIBE_TYPEHASH',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '_delegate', type: 'address' }],
        name: 'addDelegate',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address[]', name: '_channelList', type: 'address[]' },
        ],
        name: 'batchSubscribe',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address[]', name: '_channelList', type: 'address[]' },
        ],
        name: 'batchUnsubscribe',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes', name: '_publicKey', type: 'bytes' }],
        name: 'broadcastUserPublicKey',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'chainID',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'chainName',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_channel', type: 'address' },
            { internalType: 'uint256', name: '_notifID', type: 'uint256' },
            { internalType: 'string', name: '_notifSettings', type: 'string' },
        ],
        name: 'changeUserChannelSettings',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'completeMigration',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '', type: 'address' },
            { internalType: 'address', name: '', type: 'address' },
        ],
        name: 'delegatedNotificationSenders',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes', name: '_publicKey', type: 'bytes' }],
        name: 'getWalletFromPublicKey',
        outputs: [{ internalType: 'address', name: 'wallet', type: 'address' }],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [],
        name: 'governance',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_pushChannelAdmin', type: 'address' },
            { internalType: 'string', name: '_chainName', type: 'string' },
        ],
        name: 'initialize',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'isMigrationComplete',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_channel', type: 'address' },
            { internalType: 'address', name: '_user', type: 'address' },
        ],
        name: 'isUserSubscribed',
        outputs: [{ internalType: 'bool', name: 'isSubscriber', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        name: 'mapAddressUsers',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_startIndex', type: 'uint256' },
            { internalType: 'uint256', name: '_endIndex', type: 'uint256' },
            { internalType: 'address[]', name: '_channelList', type: 'address[]' },
            { internalType: 'address[]', name: '_usersList', type: 'address[]' },
        ],
        name: 'migrateSubscribeData',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '', type: 'address' }],
        name: 'nonces',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'pushChannelAdmin',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '_delegate', type: 'address' }],
        name: 'removeDelegate',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_channel', type: 'address' },
            { internalType: 'address', name: '_recipient', type: 'address' },
            { internalType: 'bytes', name: '_identity', type: 'bytes' },
            { internalType: 'uint256', name: 'nonce', type: 'uint256' },
            { internalType: 'uint256', name: 'expiry', type: 'uint256' },
            { internalType: 'uint8', name: 'v', type: 'uint8' },
            { internalType: 'bytes32', name: 'r', type: 'bytes32' },
            { internalType: 'bytes32', name: 's', type: 'bytes32' },
        ],
        name: 'sendNotifBySig',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_channel', type: 'address' },
            { internalType: 'address', name: '_recipient', type: 'address' },
            { internalType: 'bytes', name: '_identity', type: 'bytes' },
        ],
        name: 'sendNotification',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_coreAddress', type: 'address' },
        ],
        name: 'setEPNSCoreAddress',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_governanceAddress', type: 'address' },
        ],
        name: 'setGovernanceAddress',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '_channel', type: 'address' }],
        name: 'subscribe',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'channel', type: 'address' },
            { internalType: 'uint256', name: 'nonce', type: 'uint256' },
            { internalType: 'uint256', name: 'expiry', type: 'uint256' },
            { internalType: 'uint8', name: 'v', type: 'uint8' },
            { internalType: 'bytes32', name: 'r', type: 'bytes32' },
            { internalType: 'bytes32', name: 's', type: 'bytes32' },
        ],
        name: 'subscribeBySig',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_channel', type: 'address' },
            { internalType: 'address', name: '_user', type: 'address' },
        ],
        name: 'subscribeViaCore',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '_newAdmin', type: 'address' }],
        name: 'transferPushChannelAdminControl',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '_channel', type: 'address' }],
        name: 'unsubscribe',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'channel', type: 'address' },
            { internalType: 'uint256', name: 'nonce', type: 'uint256' },
            { internalType: 'uint256', name: 'expiry', type: 'uint256' },
            { internalType: 'uint8', name: 'v', type: 'uint8' },
            { internalType: 'bytes32', name: 'r', type: 'bytes32' },
            { internalType: 'bytes32', name: 's', type: 'bytes32' },
        ],
        name: 'unsubscribeBySig',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '', type: 'address' },
            { internalType: 'address', name: '', type: 'address' },
        ],
        name: 'userToChannelNotifs',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '', type: 'address' }],
        name: 'users',
        outputs: [
            { internalType: 'bool', name: 'userActivated', type: 'bool' },
            { internalType: 'bool', name: 'publicKeyRegistered', type: 'bool' },
            { internalType: 'uint256', name: 'userStartBlock', type: 'uint256' },
            { internalType: 'uint256', name: 'subscribedCount', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'usersCount',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: '_channelAddress', type: 'string' },
        ],
        name: 'verifyChannelAlias',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
//# sourceMappingURL=comm.js.map